import { render, staticRenderFns } from "./ProgressButton.vue?vue&type=template&id=a5b1fd30&"
import script from "./ProgressButton.vue?vue&type=script&lang=js&"
export * from "./ProgressButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports